import {useContext, useState} from "react";
import Header from "../components/header/Header.jsx";
import PageTitle from "../components/PageTitle.jsx";
import Sidebar from "../components/sidebar/Sidebar.jsx";
import Spinner from "../components/Spinner.jsx";
import {useRequireLoginEffect} from "../components/auth/useRequireLoginEffect.js";
import {GlobalContext} from "../utils/context/GlobalContextProvider.jsx";
import Sticky from "react-stickynode";
import AppAlerts from "./AppAlerts.jsx";

export default function NarrowSecureLayout({title, actions, children, alerts = [], hiddenAlertIds = [], compactHeaderSpacing = false}) {

    const {context} = useContext(GlobalContext);

    const [sidebarOpen, setSidebarOpen] = useState(false);

    useRequireLoginEffect();

    return (
        <div className="flex h-[100dvh] overflow-hidden">

            {/* Sidebar */}
            <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen}/>

            {/* Content area */}
            <div className="relative flex flex-col flex-1 overflow-y-auto overflow-x-hidden">

                {/*  Site header */}
                <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen}/>

                <main className="layout-narrow grow px-4 sm:px-6 lg:px-8">
                    <div className="pt-2 sm:pt-4 md:pt-6 pb-8 w-full max-w-9xl mx-auto">
                        <div className="max-w-3xl mx-auto">

                            {(title || actions) &&
                                <Sticky>
                                    <div
                                        className={`mb-4 flex items-start justify-between gap-3 text-left ${compactHeaderSpacing ? '' : 'sm:mb-6 md:mb-8'}`}
                                    >
                                        {title &&
                                            <PageTitle textSizeClass={'min-w-0 text-2xl md:text-3xl'}>{title}</PageTitle>
                                        }
                                        {actions &&
                                            <div className={'my-auto shrink-0'}>{actions ?? null}</div>
                                        }
                                    </div>
                                </Sticky>
                            }

                                <AppAlerts alerts={alerts} hiddenAlertIds={hiddenAlertIds} compactTopSpacing={compactHeaderSpacing} />

                                <div>
                                    {context.currentIdentity === null ? <Spinner/> : children}
                                </div>
                            </div>
                        </div>
                </main>
            </div>
        </div>
    );
}
